export default __webpack_public_path__ + "static/media/GR00054-owl_50_disciple.de8ea6fb.svg";